<template>
  <div class="team-invite-container">
    <!-- 主要内容区域已隐藏，相关功能通过任务侧交互触发 -->
    <!-- 所有弹窗保留，供 hooks 中的 trigger 方法调用 -->

    <!-- 解散队伍确认弹窗 -->
    <div v-if="showBreakTeam" class="popup-overlay" @click="showBreakTeam = false">
      <div class="popup-content" @click.stop>
        <div class="popup-title">确认解散队伍？</div>
        <div class="popup-actions">
          <button class="btn-confirm" @click="handleConfirmBreakTeam">确认</button>
          <button class="btn-cancel" @click="showBreakTeam = false">取消</button>
        </div>
      </div>
    </div>

    <!-- 退出队伍确认弹窗 -->
    <div v-if="showExitTeam" class="popup-overlay" @click="showExitTeam = false">
      <div class="popup-content" @click.stop>
        <div class="popup-title">确认退出队伍？</div>
        <div class="popup-actions">
          <button class="btn-confirm" @click="handleConfirmExitTeam">确认</button>
          <button class="btn-cancel" @click="showExitTeam = false">取消</button>
        </div>
      </div>
    </div>

    <!-- 提示信息弹窗 -->
    <BasePopup
      v-model:visible="showBreakTeamTip"
      popup-class="rule-popup"
      :mask-closable="true"
      :show-confirm-btn="true"
    >
      <div style="text-align: center; padding: 20px 0;">队伍有其他成员时无法解散，请先让成员退出</div>
    </BasePopup>

    <!-- 奖励详情弹窗 -->
    <BasePopup
      v-model:visible="showAwardDetail"
      popup-class="rule-popup"
      :mask-closable="true"
      :show-confirm-btn="true"
    >
      <div v-html="currentAwardDetail"></div>
    </BasePopup>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useTeamInvite } from '@/hooks/useTeamInvite';
import BasePopup from './popup/BasePopup.vue';
import type { Ref } from 'vue';

// 使用 Hook
const {
  showBreakTeam,
  showExitTeam,
  showAwardDetail,
  showBreakTeamTip,
  currentAwardDetail,
  confirmBreakTeam,
  confirmExitTeam,
} = useTeamInvite({});

// 注入的方法（从 App.vue 提供）
const showTips = inject<(msg: string) => void>('showTipMessage', (msg) => console.log(msg));
const myCode = inject<Ref<string>>('myCode', { value: '' } as Ref<string>);

// ========== 事件处理 ==========

const handleConfirmBreakTeam = async () => {
  await confirmBreakTeam(showTips);
};

const handleConfirmExitTeam = async () => {
  await confirmExitTeam(showTips);
};

</script>
